import * as React from 'react'
import { createPortal } from 'react-dom'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { useGetDatoModules } from 'modules/marketplace_modules/hooks/useGetDatoModules'

import Animation from './_Animation'

const OneWaitlistOverlay: React.FC = () => {
  const [mounted, setMounted] = React.useState(false)
  const [isOpen, setIsOpen] = React.useState(false)

  const STORAGE_KEY = 'one-waitlist-overlay-closed'

  const { data: moduleData } = useGetDatoModules({
    locale: 'en',
    slug: 'one',
    showHiddenModules: true,
  })

  React.useEffect(() => {
    setMounted(true)

    const closedTimestamp = localStorage.getItem(STORAGE_KEY)

    if (!closedTimestamp) {
      setIsOpen(true)
    }

    return () => setMounted(false)
  }, [])

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
      track(trackingEvents.upsell.viewOneBetaMotion)
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const handleClose = React.useCallback(() => {
    setIsOpen(false)
    localStorage.setItem(STORAGE_KEY, Date.now().toString())
  }, [])

  if (!mounted || !isOpen) {
    return null
  }

  const overlayContent = (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300"
      style={{ backgroundColor: '#011B4B5E' }}
      onClick={handleClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="overlay-title"
    >
      <div
        className="relative max-h-screen max-w-screen overflow-auto p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <Animation onClose={handleClose} moduleData={moduleData} />
      </div>
    </div>
  )

  // Render the modal in a portal to ensure it appears above all other content
  return createPortal(overlayContent, document.body)
}

export default OneWaitlistOverlay
